
const Service = () => {
    return (
        <>
            <section className="service_section layout_padding">
                <div className="container">
                    <div className="heading_container heading_center ">
                        <h2 className="">Our Services</h2>
                        <p className="col-lg-8 px-0">
                            If you are going to use a passage of Lorem Ipsum, you need to be sure
                            there isn't anything believable. If you are going to use a passage of
                            Lorem Ipsum, you need to be sure there isn't anything
                        </p>
                    </div>
                    <div className="service_container">
                        <div className="carousel-wrap ">
                            <div className="service_owl-carousel owl-carousel">
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s1.png" alt="Home Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Home Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s4.png" alt="Machine Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Machine Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s6.png" alt="Car Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Car Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s1.png" alt="Home Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Home Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s4.png" alt="Machine Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Machine Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="box ">
                                        <div className="img-box">
                                            <img src="/images/s6.png" alt="Car Welding" />
                                        </div>
                                        <div className="detail-box">
                                            <h5>Car Welding</h5>
                                            <p>
                                                when looking at its layout. The point of using Lorem Ipsum is
                                                that it has a more-or-less normal
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn-box">
                        <a href="">Read More</a>
                    </div>
                </div>
            </section>
        </>
    )
};

export default Service;
